import {Component, input} from "@angular/core";
import {Translations} from "@translations";
import {SimStatusPalette} from "@models";
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
	selector: "sim-info-hover",
	templateUrl: "./info-hover.component.html",
	styleUrl: "./info-hover.component.scss",
	imports: [MatIcon, TranslateModule, MatTooltip],
	host: {
		"[@zoomInOnEnter]": "true",
		"[@zoomOutOnLeave]": "true",
		class: SimStatusPalette.busy,
	},
})
export class InfoHoverComponent {
	public readonly tooltip = input.required<string>();
	protected readonly T = Translations;
	protected readonly SimStatusPalette = SimStatusPalette;
}
